<template>
  <div>
    <v-dialog v-model="selectTemplateModal" max-width="400">
      <v-card class="card-container pa-4">
        <h3 class="text-center">{{ $t('Seleção de Template') }}</h3>
        <p>
          {{
            $t(
              'Selecione o template em que todos os itens selecionados serão cadastrados'
            )
          }}
        </p>

        <v-form ref="templateForm">
          <v-autocomplete
            v-model="selectedTemplate"
            :items="templates"
            item-text="name"
            item-value="id"
            :loading="templatesLoading"
            class="primary-input"
            placeholder="Selecione"
            outlined
            :rules="[(v) => !!v || 'Template obrigatório']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-form>

        <div class="d-flex justify-end">
          <v-btn
            :loading="saveTemplateLoading"
            depressed
            class="primary-button"
            @click="saveInTemplate"
          >
            {{ $t('Confirmar') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600">
      <ManageChecklistItem
        title="Editar Item Checklist"
        :checklistItem="currentChecklistItem"
        @close="closeDialog"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t('Tem certeza de que deseja excluir este item de checklist?')
            }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="remove"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteManyDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza que deseja excluir os item selecionado?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            depressed
            @click="deleteManyDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            depressed
            @click="removeMany"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="loadModal" max-width="500px">
      <v-card class="card-pad mx-auto" width="500">
        <div class="text-center pa-3">
          <h3>
            {{ $t('Selecione os equipamentos que deseja importar.') }}
          </h3>
          <div class="d-flex justify-center px-4">
            <v-checkbox
              class="pr-3"
              v-model="departmentTypes"
              label="Engenharia clinica"
              :value="0"
            ></v-checkbox>
            <v-checkbox
              v-model="departmentTypes"
              label="Manutenção predial"
              :value="1"
            ></v-checkbox>
          </div>
          <div class="d-flex justify-center px-4">
            <v-btn class="ma-1" color="grey" text @click="loadModal = false">
              Cancelar
            </v-btn>

            <v-btn
              class="ma-1"
              color="secondary"
              text
              @click="loadChecklistItems"
            >
              {{ $t('Importar') }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <div class="hidden-sm-and-down mt-2">
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          color="#0F3565"
          dark
          class="ma-1 secondary-button"
          @click="addChecklistItem"
          depressed
        >
          {{ $t('Novo item') }}
        </v-btn>
        <v-btn
          color="#0F3565"
          v-show="buttonDeleteVisible"
          dark
          class="ma-1 terciary-button"
          @click="sendSelected"
          depressed
        >
          {{ $t('Enviar selecionados') }}
        </v-btn>
        <v-btn
          color="#0F3565"
          dark
          class="ma-1 terciary-button"
          @click="loadModal = true"
          depressed
        >
          {{ $t('Carregar itens padrão') }}
        </v-btn>
        <v-btn
          v-show="buttonDeleteVisible"
          v-if="mainType == 0 || mainType == 1 || institution.userType <= 2"
          class="ma-1 quaternary-button"
          color="#A42A2AD9"
          dark
          depressed
          @click="deleteManyChecklistItem"
        >
          Remover selecionados
        </v-btn>
        <v-btn
          class="ma-1 primary-button"
          dark
          depressed
          @click="visible = !visible"
        >
          Filtros
        </v-btn>
      </div>
    </div>

    <div class="my-5 back hidden-md-and-up">
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          small
          class="mr-2"
          color="#0F3565"
          dark
          @click="addChecklistItem"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn
          depressed
          v-show="buttonDeleteVisible"
          v-if="mainType == 0 || mainType == 1 || institution.userType <= 2"
          small
          class="mr-2"
          color="#A42A2AD9"
          dark
          @click="deleteManyChecklistItem"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="600">
          <ManageChecklistItem
            title="Novo Item Checklist"
            @close="closeDialog"
            :key="dialogKey"
          />
        </v-dialog>

        <v-btn
          depressed
          class=""
          small
          color="#BBCF20"
          dark
          @click="visible = !visible"
        >
          <v-icon> mdi-filter </v-icon>
        </v-btn>
      </div>
    </div>

    <v-expand-transition>
      <div v-show="visible" class="mb-2">
        <v-row class="ma-0" dense>
          <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
            <label class="label">{{ $t('Item checklist') }}</label>
            <v-text-field
              hide-details="auto"
              name="name"
              v-model="checklistItemName"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="6" lg="6">
            <label class="label">{{ $t('Classe') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="checklistItemClassId"
              :items="checklistItemClasses"
              item-value="id"
              item-text="name"
              :loading="classLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn
              class="mx-1 secondary-button"
              color="#BBCF20"
              @click="filterTable"
              depressed
            >
              <span>Filtrar</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              depressed
              color="#20202066"
              class="clear-button mr-0"
              @click="reset"
            >
              <span>Limpar</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <div class="wrapper mobile">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum item de checklist encontrado')"
        :headers="headersMobile"
        :items="checklistItems"
        v-model="checklistItemsSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        :items-per-page="pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        :expanded.sync="expanded"
      >
        <template #[`item.name`]="{ item }">
          {{ item.name }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                color="#0F3565"
                dark
                @click.stop="editChecklistItem(item)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon dark small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>

          <v-tooltip
            bottom
            v-if="mainType == 0 || mainType == 1 || institution.userType <= 2"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                x-small
                color="#A42A2AD9"
                style="font-weight: bold"
                dark
                v-bind="attrs"
                @click="deleteChecklistItem(item)"
                v-on="on"
              >
                <v-icon small color="white"> mdi-trash-can-outline </v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Classe:</strong>
                {{ item.checklistItemClass.name }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>Item padrão:</strong>
                {{ item.isPattern ? $t('Sim') : $t('Não') }}
              </p>
            </v-col>

            <v-col v-if="userType < 1" class="ma-0 pa-0" cols="12">
              <p>
                <strong>Ações: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      x-small
                      color="#A42A2AD9"
                      style="font-weight: bold"
                      dark
                      v-bind="attrs"
                      @click="deleteChecklistItem(item)"
                      v-on="on"
                    >
                      <v-icon small color="white">
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>Selceionados: {{ checklistItemsSelected.length }}</span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum item de checklist encontrado')"
        :headers="headers"
        :items="checklistItems"
        v-model="checklistItemsSelected"
        :single-select="false"
        item-key="id"
        show-select
        class="main-table"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        :items-per-page="pageSize"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.name`]="{ item }">
          {{ item.name }}
        </template>

        <template #[`item.class`]="{ item }">
          {{ item.checklistItemClass.name }}
        </template>

        <template #[`item.isPattern`]="{ item }">
          {{ item.isPattern ? $t('Sim') : $t('Não') }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#0F3565"
                @click.stop="editChecklistItem(item)"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>

          <v-tooltip bottom v-if="userType < 1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                small
                color="#A42A2AD9"
                style="font-weight: bold"
                v-bind="attrs"
                @click="deleteChecklistItem(item)"
                v-on="on"
              >
                <v-icon small color="white"> mdi-trash-can-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Excluir') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>

      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
            <!-- <span>Selceionados: {{ checklistItemsSelected.length }}</span> -->
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/sass/variables.scss';
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'
import ManageChecklistItem from './ManageChecklistItem.vue'

export default {
  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institutionId
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.mainType = JSON.parse(localStorage.getItem('institution')).mainType
    this.getChecklisItemClasses()
    this.updateTable()
  },

  data: () => ({
    templates: [],
    institution: {},
    selectedTemplate: null,
    mainType: null,
    institutionId: '',
    visible: false,
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    dialogKey: false,
    loading: false,
    classLoading: false,
    error: false,
    buttonDeleteVisible: false,
    expanded: [],
    checklistItemClassId: null,
    checklistItemClasses: [],
    checklistItemsSelected: [],
    checklistItems: [],
    currentChecklistItem: {},
    userType: null,
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    totalItensOnPage: 0,
    filter: {
      page: 1,
      pageSize: 10,
      classId: null,
      name: null,
    },
    checklistItemName: null,
    mainType: null,
    headers: [
      {
        text: 'Item Checklist',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Classe',
        align: 'center',

        value: 'class',
      },
      {
        text: 'Item Padrão',
        align: 'center',

        value: 'isPattern',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Item Checklist',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    selectTemplateModal: false,
    templatesLoading: false,
    saveTemplateLoading: false,
    departmentTypes: [],
    loadModal: false,
  }),

  components: {
    ManageChecklistItem,
  },

  methods: {
    saveInTemplate() {
      if (this.$refs.templateForm.validate()) {
        this.saveTemplateLoading = true
        this.apiService
          .post('checklistTemplate/addItems', {
            templateId: this.selectedTemplate,
            items: this.checklistItemsSelected.map((x) => x.id),
          })
          .then(() => {
            this.saveTemplateLoading = false
            this.selectTemplateModal = false
            this.$toast.success('Itens adicionados com sucesso!')
          })
          .catch(() => {
            this.saveTemplateLoading = false
          })
      }
    },

    addChecklistItem() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    getTemplates() {
      this.templatesLoading = true
      this.apiService
        .get(`checklistTemplate/list/${this.institutionId}`)
        .then((response) => {
          this.templates = response.content
          this.templatesLoading = false
        })
        .catch(() => {
          this.templatesLoading = false
        })
    },

    sendSelected() {
      this.selectedTemplate = null
      this.getTemplates()
      this.selectTemplateModal = true
    },

    async loadChecklistItems() {
      this.loading = true

      const model = {
        institutionId: this.institutionId,
        departmentTypes: this.departmentTypes,
      }

      await this.apiService
        .post(`standardChecklistItem/load`, model)
        .then(() => {
          this.loading = false
          this.loadModal = false
          this.updateTable()
        })
        .catch(() => {
          this.loading = false
        })
    },

    editChecklistItem(checklistItem) {
      this.currentChecklistItem = checklistItem
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteChecklistItem(checklistItem) {
      this.currentChecklistItem = checklistItem
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManyChecklistItem() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false

      this.updateTable()
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.classId = this.checklistItemClassId
      this.filter.name = this.checklistItemName
      this.filter.institutionId = this.institutionId
      this.updateTable()
    },

    async updateTable() {
      this.loading = true

      await this.apiService
        .post('checklistItem/list', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.checklistItems = response.content.checklistItems
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.checklistItems.length
          this.loading = false
        })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('checklistItem/delete', this.currentChecklistItem)
        .then(() => {
          this.loading = false
          this.deleteDialog = false
          this.updateTable()
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('checklistItem/deleteMany', this.checklistItemsSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.checklistItemsSelected = []
    },

    async getChecklisItemClasses() {
      this.classLoading = true

      await this.apiService
        .get(`checklistItemClass/list/${this.institutionId}`)
        .then((resposne) => {
          this.checklistItemClasses = resposne.content
          this.classLoading = false
        })
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 10,
        checklistItemClassId: null,
        name: null,
      }
      this.checklistItemClassId = 0
      this.checklistItemName = null

      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    checklistItemsSelected() {
      this.buttonDeleteVisible = this.checklistItemsSelected.length > 0
    },
  },
}
</script>
